import { createAction } from 'redux-actions';

export const insurersFetch = createAction('HOME_INSURERS_FETCH');
export const insurersSet = createAction('HOME_INSURERS_SET');
